import React from 'react';

const NotFound: React.FC = () => {
  return <h1 data-testid="not-found">404</h1>;
};

export default NotFound;
